import React from 'react'
import { Switch, Route } from 'react-router-dom'

import AddWitness from './AddWitness'
import Witness from './Witness.container'

const routes = () => {
  return (
    <Switch>
      <Route path='/claims/witness/new' component={AddWitness} />
      <Route path='/claims/witness' component={Witness} />
    </Switch>
  )
}

export default routes
